import { useEffect } from 'react';
import InterestAccountTransactionSearchForm from './InterestAccountTransactionSearchForm';
import InterestAccountTransactionTable from './InterestAccountTransactionTable';
import { useAlertDialog } from '@/providers/AlertDialog.provider';
import { useTranslation } from 'react-i18next';
import { SupportedCurrencies, InterestAccountTransactionsRequest } from 'vopay';
import { Paginator } from 'UI';
import useTransactionsearch from './useTransactionSearch';

type TransactionsTabProps = {
  hasLongTermAccount: boolean;
  currency: SupportedCurrencies;
};

export default function TransactionsTab({ hasLongTermAccount, currency }: TransactionsTabProps) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const alertDialog = useAlertDialog();
  const tableID = 'interestAccountTransactionHistory';

  const { transactions, fetching, filterTransactions, pageCount, pageIndex, changePageOffset } = useTransactionsearch();

  useEffect(() => {
    filterTransactions();
  }, []);

  async function refreshTransactions(req?: Omit<InterestAccountTransactionsRequest, 'Limit' | 'Offset'>) {
    try {
      await filterTransactions({
        ...req,
      });
    } catch (err) {
      if (err instanceof Error) {
        alertDialog.error(tGlobal('error'), err.message);
      }
    }
  }

  async function changePage(offset: number) {
    try {
      await changePageOffset(offset);
    } catch (err) {
      if (err instanceof Error) {
        alertDialog.error(tGlobal('error'), err.message);
      }
    }
  }

  return (
    <>
      <InterestAccountTransactionSearchForm
        hasLongTermAccount={hasLongTermAccount}
        onSearch={refreshTransactions}
        disabled={fetching}
        tableID={tableID}
      />

      <InterestAccountTransactionTable
        fetching={fetching}
        transactions={transactions}
        currency={currency}
        id={tableID}
      />

      {pageCount > 1 && (
        <div
          // I really don't think it's worth making a whole new stylesheet just for this one declaration (I also don't like sharing stylesheets as it's hard to debug later)
          style={{
            margin: '0 auto',
          }}
        >
          <Paginator
            pageCount={pageCount}
            onPageChange={(e) => {
              changePage(e.selected);
            }}
            pageOffset={pageIndex}
          />
        </div>
      )}
    </>
  );
}
